import type { NotificationDeliveryListInput } from '@repo/api-contracts';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api';

/**
 * 어드민 알림 발송 이력(notificationManagement.listDeliveries, 알림 설계 §6-1). 조건은 쪽·종류·결과·기간·수신 이메일이다.
 * 조건을 바꾸는 동안 이전 쪽 표를 자리표시자로 유지한다. 서버가 조회 전에 관리자 접속기록(PII_ACCESSED, notifications.list)을 남긴다.
 */
export const useNotificationDeliveriesQuery = (input: NotificationDeliveryListInput) =>
  trpc.notificationManagement.listDeliveries.useQuery(input, {
    placeholderData: keepPreviousData,
  });
